import React from 'react'

export function StatCard({
  className,
  delay,
  iconClass,
  icon,
  label,
  value,
  delta,
}: {
  className: string
  delay: string
  iconClass: string
  icon: React.ReactNode
  label: string
  value: React.ReactNode
  delta: React.ReactNode
}) {
  return (
    <div className={`stat-card ${className}`} style={{ animationDelay: delay }}>
      <div className={`stat-icon ${iconClass}`}>{icon}</div>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      <div className="stat-delta">{delta}</div>
    </div>
  )
}

